<template>
    <div class="absolute inset-0 top-0 max-h-screen">
        <svg width="219" height="600" viewBox="0 0 219 600" class="absolute left-0 top-0" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="-210.5" cy="233.5" r="429.5" fill="#E19329" />
        </svg>
        <svg
            width="859"
            class="pointer-events-none absolute right-1/2 top-[30%] z-0 translate-x-1/2"
            height="380"
            viewBox="0 0 859 380"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="429.5" cy="429.5" r="429.5" fill="#9747FF" />
        </svg>
        <svg
            width="790"
            class="pointer-events-none absolute right-0 top-[30%] z-0"
            height="380"
            viewBox="0 0 790 380"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="429.5" cy="429.5" r="429.5" fill="#1685B3" />
        </svg>
    </div>
</template>
